import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Catch unhandled errors from Firebase Auth in restricted browsers
window.addEventListener('error', (e) => {
  if (e.message?.includes('missing initial state') || e.message?.includes('sessionStorage')) {
    e.preventDefault();
    document.body.innerHTML = `
      <div style="padding:40px;text-align:center;font-family:Arial;color:#333">
        <div style="font-size:48px;margin-bottom:16px">🌳</div>
        <h2 style="color:#5B8C51;margin-bottom:8px">LegacyRoots</h2>
        <p style="color:#888;margin-bottom:20px">Please open this link in your regular browser (Safari/Chrome) instead of the in-app browser.</p>
        <a href="https://legacyroots.ai" style="padding:12px 24px;background:#5B8C51;color:#fff;text-decoration:none;border-radius:12px;font-weight:bold">Open in Browser</a>
      </div>
    `;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
